import { render, staticRenderFns } from "./Shorts.vue?vue&type=template&id=b55bdce8&scoped=true"
import script from "./Shorts.vue?vue&type=script&lang=js"
export * from "./Shorts.vue?vue&type=script&lang=js"
import style0 from "./Shorts.vue?vue&type=style&index=0&id=b55bdce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55bdce8",
  null
  
)

export default component.exports